// 仓库设置
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid
            :stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%"
            ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
            @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog" v-if="warehouse_add">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                  <!--                              status="primary" plain>重置</vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                        @submit="searchEvent" @reset="searchEvent">
                <vxe-form-item title="仓库编码:" field="code">
                  <template v-slot>
                    <el-input v-model="formData.warehouseCode" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="仓库名称:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.warehouseName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="仓库类型:" field="name">
                  <template v-slot>
                    <el-select v-model="formData.warehouseType">
                      <el-option label="总部仓" :value="0"/>
                      <el-option label="机构仓" :value="1"/>
                      <el-option label="代理仓" :value="2"/>
                      <!--                      <el-option label="网点仓" :value="3" />-->
                    </el-select>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";

export default {
  name: 'warehouse',

  mixins: [indexPageMixins],
  components: {editView, pager},
  data() {
    return {
      warehouse_edit: false,
      warehouse_add: false,
      total: 0,
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      getListPageUrl: '/basic/basWarehouse/getListPage',
      vxeOption: {},
      requestParam: {
        size: 0,
        current: 1,
        searchCount: false,
        warehouseName: '',
        warehouseCode: '',
        warehouseType: null,
        excludeWarehouseType: [3]
      },
      editViewDataUpdateFlag: false,
      formData: {
        warehouseName: null,
        warehouseCode: null,
        warehouseType: null,
        excludeWarehouseType: [3]
      },
      pageSizes: [10, 20, 100],
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '仓库编码', field: 'warehouseCode', width: 140,},
        {title: '仓库名称', field: 'warehouseName', width: 140,},
        {
          title: '仓库类型', field: 'warehouseType', width: 80, slots: {
            default: ({row}) => {
              if (row.warehouseType == 0) {
                return [
                  <div>
                    <span>总部仓</span>
                  </div>
                ];
              } else if (row.warehouseType == 1) {
                return [
                  <div>
                    <span>机构仓</span>
                  </div>
                ];
              } else if (row.warehouseType == 2) {
                return [
                  <div>
                    <span>代理仓</span>
                  </div>
                ];
              } else if (row.warehouseType == 3) {
                return [
                  <div>
                    <span>网点仓</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '配件代理网点', field: 'proxySiteName', width: 150,},
        {
          title: '是否配件仓', field: 'isPartsWare', width: 90, slots: {
            default: ({row}) => {
              if (row.isPartsWare == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isPartsWare == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '是否产品仓', field: 'isItemWare', width: 90, slots: {
            default: ({row}) => {
              if (row.isItemWare == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isItemWare == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '所属网点', field: 'siteName', width: 100,},
        {
          title: '库存是否对网点开放', field: 'isPublic', width: 140, slots: {
            default: ({row}) => {
              if (row.isPublic == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isPublic == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '是否默认为配件申请出库仓', field: 'isOutDefault', width: 180, slots: {
            default: ({row}) => {
              if (row.isOutDefault == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isOutDefault == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '是否外部对接仓库', field: 'isInterfaceWarehouse', width: 140, slots: {
            default: ({row}) => {
              if (row.isInterfaceWarehouse == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isInterfaceWarehouse == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '限额', field: 'quota', width: 70,},
        {
          title: '是否为好件返厂入库仓', field: 'isGoodReturnDefault', width: 150,
          slots: {
            default: ({row}) => {
              if (row.isGoodReturnDefault == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isGoodReturnDefault == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '是否为旧件返厂入库仓', field: 'isOldReturnDefault', width: 150, slots: {
            default: ({row}) => {
              if (row.isOldReturnDefault == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isOldReturnDefault == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '启用', field: 'usable', width: 90,
          slots: {
            default: ({row}) => {
              if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.usable == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
        {field: 'createTime', title: '创建时间', width: 150},
        {title: '创建人', field: 'createBy', width: 100,},
        {
          width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ]
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.warehouse_edit = this.permissions['warehouse_edit']
    this.warehouse_add = this.permissions['warehouse_add']
  },
  methods: {
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.formData.warehouseName = ''
      this.formData.warehouseCode = ''
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.warehouseName = ''
      this.requestParam.warehouseCode = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}</style>
